import { render, staticRenderFns } from "./NotificationAgreementAnswer.vue?vue&type=template&id=3fc29fb8&scoped=true&lang=pug&"
import script from "./NotificationAgreementAnswer.vue?vue&type=script&lang=js&"
export * from "./NotificationAgreementAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc29fb8",
  null
  
)

export default component.exports